export interface ErrorDiagnostic {
  type: 'onerror' | 'unhandledrejection' | 'boundary' | 'console';
  error?: string;
  reason?: any;
  stack?: string;
  componentStack?: string;
  timestamp: string;
  url?: string;
  userAgent?: string;
}

declare global {
  interface Window {
    __FE_DIAG__: ErrorDiagnostic[];
  }
}

export function installGlobalErrorHandlers() {
  // Inicializa array de diagnóstico
  window.__FE_DIAG__ = window.__FE_DIAG__ || [];

  // Captura erros globais
  window.addEventListener('error', (event) => {
    const diagnostic: ErrorDiagnostic = {
      type: 'onerror',
      error: event.error?.message || event.message,
      stack: event.error?.stack,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
    };

    window.__FE_DIAG__.push(diagnostic);
    console.error('Global error caught:', diagnostic);
  });

  // Captura promessas rejeitadas não tratadas
  window.addEventListener('unhandledrejection', (event) => {
    const diagnostic: ErrorDiagnostic = {
      type: 'unhandledrejection',
      reason: event.reason,
      error: event.reason?.message || String(event.reason),
      timestamp: new Date().toISOString(),
      url: window.location.href,
      userAgent: navigator.userAgent,
    };

    window.__FE_DIAG__.push(diagnostic);
    console.error('Unhandled promise rejection:', diagnostic);
  });

  // Intercepta console.error e console.warn
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    const diagnostic: ErrorDiagnostic = {
      type: 'console',
      error: args.map(arg => 
        typeof arg === 'string' ? arg : 
        arg instanceof Error ? arg.message : 
        JSON.stringify(arg)
      ).join(' '),
      timestamp: new Date().toISOString(),
      url: window.location.href,
    };

    window.__FE_DIAG__.push(diagnostic);
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    const diagnostic: ErrorDiagnostic = {
      type: 'console',
      error: `WARN: ${args.map(arg => 
        typeof arg === 'string' ? arg : 
        arg instanceof Error ? arg.message : 
        JSON.stringify(arg)
      ).join(' ')}`,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    };

    window.__FE_DIAG__.push(diagnostic);
    originalWarn.apply(console, args);
  };

  // Log inicial
  console.log('GlobalErrorHandler instalado');
}

export function getErrorDiagnostics(): ErrorDiagnostic[] {
  return window.__FE_DIAG__ || [];
}

export function clearErrorDiagnostics(): void {
  window.__FE_DIAG__ = [];
}

export function exportErrorDiagnostics(): string {
  return JSON.stringify(window.__FE_DIAG__ || [], null, 2);
}
